import script from "./BottomActionsContainer.vue?vue&type=script&setup=true&lang=ts"
export * from "./BottomActionsContainer.vue?vue&type=script&setup=true&lang=ts"

import "./BottomActionsContainer.vue?vue&type=style&index=0&id=1f0dd99b&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1f0dd99b"]])

export default __exports__